//import React, { useState, useEffect } from "react";
import React, { useState, useCallback } from "react";

import axios from "axios";
import GetDistricts from "../../Dropdowns/getDistricts";
import BankReopenPage from "../BankDetailsApproval/BankReopenPage";

const API_URL = process.env.REACT_APP_URL;
const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

export default function BankReopen() {
    const currentYear = new Date().getFullYear();
    const availableYears = [
        currentYear - 1,
        currentYear,
        currentYear + 1
    ];

    const [state, setState] = useState({
        district: "",
        districtName: "",
        month: new Date().getMonth() + 1,
        year: currentYear,
        records: [],
        loading: false,
        message: "",
        canReopen: false,
        isFinished: false
    });

    const [selectedIds, setSelectedIds] = useState([]);
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [rejectRemark, setRejectRemark] = useState("");

    const loadReopenRecords = async () => {
        if (!state.district) {
            alert("Please select district first");
            return;
        }

        setState(prev => ({ ...prev, loading: true, message: "" }));

        try {
            const res = await axios.get(`${API_URL}/api/bank/reopen/load`, {
                params: {
                    district: state.district,
                    month: state.month,
                    year: state.year
                },
                withCredentials: true
            });

            setState(prev => ({
                ...prev,
                loading: false,
                canReopen: res.data.canReopen || false,
                message: res.data.message || "",
                records: res.data.records || [],
                districtName: res.data.districtName || state.district,
                isFinished: !res.data.canReopen
            }));

            setSelectedIds([]);
        } catch (err) {
            const errMsg = err.response?.data?.message || "Failed to load reopen records";
            setState(prev => ({ ...prev, loading: false, message: errMsg }));
        }
    };

    const handleAction = async (action) => {
        if (selectedIds.length === 0) {
            alert("Please select at least one record");
            return;
        }

        const isReject = action === "reject";
        if (isReject && !rejectRemark.trim()) {
            alert("Please select rejection remark");
            return;
        }
        if (action === "reject") {
            if (!window.confirm("Are you sure you want to REJECT the selected records?")) {
                return;
            }
        } else {
            if (!window.confirm("Are you sure you want to APPROVE the selected records?\n\nThis is FINAL — reopen facility will be closed!")) {
                return;
            }
        }

        const payload = {
            action: action === "approve" ? "reopen_approve" : "reopen_reject",
            fpsIds: selectedIds,
            district: state.district,
            month: state.month,
            year: state.year,
            ...(isReject && { remark: rejectRemark })
        };

        try {
            const res = await axios.post(`${API_URL}/api/bank/reopen/action`, payload, {
                withCredentials: true
            });

            alert(res.data.message || "Action completed");
            setShowRejectModal(false);
            setRejectRemark("");
            setSelectedIds([]);

            // Reload to show final status
            loadReopenRecords();
        } catch (err) {
            alert(err.response?.data?.message || "Action failed");
        }
    };
    const handleDistrictChange = useCallback((code) => {
        setState(prev => ({ ...prev, district: code }));
    }, []);

    const handleLoadingChange = useCallback((loading) => {
        setState(prev => ({ ...prev, loading }));
    }, []);


    return (
        <div style={{ padding: "20px", maxWidth: "1400px", margin: "0 auto" }}>

            <table width="50%" align="center" cellPadding="8" cellSpacing="0" style={{ marginTop: "20px", border: "1px solid #000", fontFamily: "Arial" }}>
                <tr className='tableheader'>
                    <th colSpan="11" >Bank Reopen For Approval</th>
                </tr>

                <tbody>
                    <tr >

                        <td><strong>District:</strong></td>
                        {/* <td>
                            <GetDistricts
                                onChange={(code) => setState(prev => ({ ...prev, district: code }))}
                            />
                        </td> */}
                        <td>
                        <GetDistricts
                            onChange={handleDistrictChange}
                            onLoadingChange={handleLoadingChange}
                        /></td>

                        <td><strong>Month:</strong></td>
                        <td>
                            <select
                                value={state.month}
                                onChange={e => setState(prev => ({ ...prev, month: +e.target.value }))}
                            >
                                {monthNames.map((name, i) => (
                                    <option key={i} value={i + 1}>{name}</option>
                                ))}
                            </select>
                        </td>

                        <td><strong>Year:</strong></td>
                        <td>
                            <select
                                value={state.year}
                                onChange={e => setState(prev => ({ ...prev, year: +e.target.value }))}
                            >
                                {availableYears.map(yr => (
                                    <option key={yr} value={yr}>
                                        {yr}
                                    </option>
                                ))}
                            </select>
                        </td>
                    </tr><tr>

                        <td colSpan="6" align="center">
                            <button
                                onClick={loadReopenRecords}
                                disabled={state.loading}
                                className="button button2"
                            >
                                {state.loading ? "Loading..." : "Submit"}
                            </button>
                        </td>

                    </tr>

                </tbody>
            </table>

            {state.message && (
                <div
                    style={{
                        padding: "16px",
                        background: state.canReopen ? "#e6ffe6" : "#fff3f3",
                        borderRadius: "6px",
                        margin: "20px auto",
                        maxWidth: "800px",
                        fontSize: "1.1em",
                        textAlign: "center",
                        fontWeight: "500",
                        lineHeight: "1.5"
                    }}
                >
                    {state.message}
                </div>
            )}

            {state.canReopen && state.records.length > 0 && !state.isFinished && (
                <BankReopenPage
                    state={{ ...state, isMonthClosed: true, isReopenMode: true }}
                    selectedIds={selectedIds}
                    setSelectedIds={setSelectedIds}
                    performAction={(action) => handleAction(action)}
                    setShowRejectModal={setShowRejectModal}
                />
            )}

            {showRejectModal && (
                <div style={{
                    position: "fixed",
                    inset: 0,
                    background: "rgba(0,0,0,0.6)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1000
                }}>
                    <div style={{
                        background: "white",
                        padding: "30px",
                        borderRadius: "10px",
                        width: "420px",
                        maxWidth: "90%"
                    }}>
                        <h3>Rejection Reason</h3>
                        <select
                            value={rejectRemark}
                            onChange={e => setRejectRemark(e.target.value)}
                            style={{ width: "100%", padding: "10px", margin: "15px 0" }}
                        >
                            <option value="">-- Select Reason --</option>
                            <option>Invalid IFSC Code</option>
                            <option>Invalid Account Number</option>
                            <option>Other</option>
                        </select>

                        <div style={{ textAlign: "right" }}>
                            <button
                                onClick={() => handleAction("reject")}
                                disabled={!rejectRemark.trim()}
                                style={{
                                    padding: "10px 24px",
                                    background: "#dc3545",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "4px",
                                    marginRight: "10px",
                                    cursor: rejectRemark.trim() ? "pointer" : "not-allowed"
                                }}
                            >
                                Confirm Reject
                            </button>
                            <button
                                onClick={() => {
                                    setShowRejectModal(false);
                                    setRejectRemark("");
                                }}
                                style={{
                                    padding: "10px 24px",
                                    background: "#6c757d",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "4px"
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}